import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "text-gray-500 text-center py-8"
}

import { computed } from "vue";
import { Site } from "@/types/v2";
import { useSitesStore } from "@/stores/v2";
import SitesListItem from "./SitesListItem.vue";

interface SitesListProps {
  sites: Site[]
}


export default /*@__PURE__*/_defineComponent({
  __name: 'SitesList',
  props: {
    sites: {}
  },
  setup(__props: any) {



const sites = computed(() => useSitesStore().getSites)

const handleSelect = (siteKey: string) => {
  useSitesStore().setActiveSite(siteKey)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (sites.value.length === 0)
      ? (_openBlock(), _createElementBlock("p", _hoisted_1, " No sites found... "))
      : _createCommentVNode("", true),
    _createElementVNode("ul", null, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(sites.value, (site) => {
        return (_openBlock(), _createBlock(SitesListItem, {
          onClick: ($event: any) => (handleSelect(site.key)),
          key: site.key,
          text: site.name,
          siteKey: site.key
        }, null, 8, ["onClick", "text", "siteKey"]))
      }), 128))
    ])
  ], 64))
}
}

})